import React, { useEffect, useRef, useState } from "react";
import {
  postAPICall,
  showToast,
  setToastRef,
  showErrorToast,
} from "../Api/Api.jsx";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";
import * as XLSX from "xlsx";
import Report from "../HomeScreenHeader/Reports/Report.jsx";
import "../HomeScreenHeader/Reports/Report.css";
import { useLoader } from "../GlobalComponents/Loader.jsx";
export default function AssetRegisterReport() {
  const [registerData, setRegisterData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [globalFilter, setGlobalFilter] = useState("");
  const toast = useRef(null);
  const [TotalTVCount, setTotalTVCount] = useState(0);
  const [TotalAssetCount, setTotalAssetCount] = useState(0);
  const { showLoader, hideLoader } = useLoader();

  const calculateTotalSum = () => {
    return registerData.reduce((sum, node) => {
      const total = ["TV 1", "TV 2", "TV 3", "TV 4", "TV 5"].reduce(
        (acc, field) => acc + (node[field] === 1 ? 1 : 0),
        0
      );
      setTotalAssetCount(registerData.length);
      return sum + total;
    }, 0);
  };
  useEffect(() => {
    setToastRef(toast.current);
    fetchRegisterData();
  }, [TotalTVCount]);

  useEffect(() => {
    const TotalTvcountSum = calculateTotalSum();
    setTotalTVCount(TotalTvcountSum);
  }, [registerData]);

  const fetchRegisterData = async () => {
    showLoader();
    const requestBody = {
      AccountGroupCode: localStorage.getItem("AccountGroupCode"),
    };

    let response = await postAPICall(
      "api/DGTReports/ReportAssetRegister",
      requestBody
    );
    if (response?.status === 200) {
      setLoading(false);
      hideLoader();
      const transformed = transformData(response?.data);
      setRegisterData(transformed);
    } else {
      hideLoader();
      setRegisterData([]);
      setLoading(false);
    }
    hideLoader();
  };
  const transformData = (data) => {
    const dataMap = new Map(data.map((node) => [node.id, node]));
    data.forEach((node) => {
      if (node.parentid) {
        const parent = dataMap.get(node.parentid);
        if (parent) {
          node.Name = `${node.Name} - ${parent.Name}`;
        }
      }
    });

    return data.map((node) => ({
      ...node,
      key: node.id.toString(),
      "TV 1": node["TV 1"] ? 1 : 0,
      "TV 2": node["TV 2"] ? 1 : 0,
      "TV 3": node["TV 3"] ? 1 : 0,
      "TV 4": node["TV 4"] ? 1 : 0,
      "TV 5": node["TV 5"] ? 1 : 0,
    }));
  };

  const exportExcel = () => {
    if (registerData.length === 0) {
      showErrorToast("No data to export.");
      return;
    }

    const calculateTotal = (data) => {
      let total = 0;
      ["TV 1", "TV 2", "TV 3", "TV 4", "TV 5"].forEach((field) => {
        if (data[field] === 1) {
          total++;
        }
      });
      return total;
    };

    const dataToExport = registerData.map((node) => ({
      Id: node.key,
      Name: node.CodeName,
      "TV 1": node["TV 1"] === 0 ? "" : node["TV 1"],
      "TV1 Version": node["TV1 Version"] || "",
      "TV 2": node["TV 2"] === 0 ? "" : node["TV 2"],
      "TV2 Version": node["TV2 Version"] || "",
      "TV 3": node["TV 3"] === 0 ? "" : node["TV 3"],
      "TV3 Version": node["TV3 Version"] || "",
      "TV 4": node["TV 4"] === 0 ? "" : node["TV 4"],
      "TV4 Version": node["TV4 Version"] || "",
      "TV 5": node["TV 5"] === 0 ? "" : node["TV 5"],
      "TV5 Version": node["TV5 Version"] || "",
      Total: calculateTotal(node),
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Asset Register");
    XLSX.writeFile(wb, "AssetRegister.xlsx");
  };

  const header = (
    <div className="Rpt_AssetRegister_SearchBox">
      <InputText
        style={{ marginLeft: "auto" }}
        type="search"
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search..."
      />
      <Button
        icon="pi pi-search"
        id="searchicon"
        style={{
          backgroundColor: "lightslategray",
          border: "lightslategray",
        }}
        title="Search"
      />
      <Button
        id="ExportExcel"
        type="button"
        icon="pi pi-file-excel"
        severity="success"
        rounded
        title="Export Excel"
        onClick={exportExcel}
        data-pr-tooltip="XLS"
      />
    </div>
  );

  const checkboxBodyTemplate = (rowData, field) => (
    <Checkbox
      checked={rowData[field] === 1}
      onChange={(e) => handleCheckboxChange(e, rowData, field)}
      disabled={rowData[field] === 0}
    />
  );

  const handleCheckboxChange = (e, rowData, field) => {
    const updatedData = [...registerData];
    const node = updatedData.find((node) => node.key === rowData.key);
    if (node) {
      if (e.checked) {
        node[field] = 1; // Set checkbox to checked (1)
      }
    }
    setRegisterData(updatedData);
  };

  const totalBodyTemplate = (rowData) => {
    const countCheckedCheckboxes = [
      "TV 1",
      "TV 2",
      "TV 3",
      "TV 4",
      "TV 5",
    ].reduce((acc, field) => (rowData[field] === 1 ? acc + 1 : acc), 0);
    return countCheckedCheckboxes;
  };

  return (
    <div>
      <Toast ref={toast} />
      <Report />
      {loading ? (
        <ProgressSpinner
          style={{ width: "50px", height: "30px", marginTop: "250px" }}
          strokeWidth="3"
        />
      ) : (
        <>
          <DataTable
            value={registerData}
            globalFilter={globalFilter}
            header={header}
            scrollable
            scrollHeight="83vh"
            style={{ width: "auto" }}
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column
              field="CodeName"
              header="Name"
              sortable
              style={{ width: "30%" }}
              footer={`Total Stores:  ${TotalAssetCount}`}
            />
            {/* <Column field="Version" header="Version" sortable/> */}
            <Column field="key" header="Id" hidden />
            <Column
              field="TV 1"
              header="TV 1"
              body={(rowData) => checkboxBodyTemplate(rowData, "TV 1")}
            />
            <Column field="TV1 Version" header="Version" sortable />
            <Column
              field="TV 2"
              header="TV 2"
              body={(rowData) => checkboxBodyTemplate(rowData, "TV 2")}
            />
            <Column field="TV2 Version" header="Version" sortable />
            <Column
              field="TV 3"
              header="TV 3"
              body={(rowData) => checkboxBodyTemplate(rowData, "TV 3")}
            />
            <Column field="TV3 Version" header="Version" sortable />
            <Column
              field="TV 4"
              header="TV 4"
              body={(rowData) => checkboxBodyTemplate(rowData, "TV 4")}
            />
            <Column field="TV4 Version" header="Version" sortable />
            <Column
              field="TV 5"
              header="TV 5"
              body={(rowData) => checkboxBodyTemplate(rowData, "TV 5")}
            />
            <Column field="TV5 Version" header="Version" sortable />
            <Column
              field="Total"
              header="Total"
              footer={`Total TV's:  ${TotalTVCount}`}
              body={totalBodyTemplate}
            />
          </DataTable>
        </>
      )}
    </div>
  );
}
